const registerAnimations = () => {
  const $ = window.$;

  var windowHeight = window.innerHeight;
  var windowWidth = window.innerWidth;
  var prepare = windowHeight/3;

  $(document).ready(function(){
      var windowScroll = $(window).scrollTop();
      $('.categories li a').on('click', function(e){
          e.preventDefault();
          
          $(this).closest('.categories').find('li a').removeClass('active');
          if( $(this).attr('data-for')  != undefined){
              $('.steps').attr('id', $(this).attr('data-for'))
          }
          if( $(this).attr('data-value')  != undefined){
              $(this).closest('ul').next('ul').attr('data-is', $(this).attr('data-value'))
          }else{
            // $('.steps').attr('data-is', '')
          }
          
          if($(this).attr('data-toggle') =="collapse"){
              $(this).closest('.categories').collapse('hide');
              var prevCategories = $(this).closest('.categories').attr('id');
              var nextCategories = $($(this).attr('href')).next().attr('id');

              if(prevCategories != undefined){
                  $('.btn-prev').attr('data-toggle',   '#'+prevCategories);   
              }else{
                  $('.btn-prev').attr('data-toggle',   '');   
              }

              if(nextCategories != undefined){
              $('.btn-next').attr('data-toggle',   '#'+nextCategories);  
              }else{
                  $('.btn-next').attr('data-toggle',   '');  
              }
          }
          $(this).addClass('active');
          //alert('clicked');
          if($(this).attr('target') == '_blank'){
            //  alert('do action');
            window.open($(this).attr('href'));
          }
        
      }); 

      $('.btn-prev, .btn-next').on('click', function(e){
          e.preventDefault();
          if($(this).attr('data-toggle') != undefined && $(this).attr('data-toggle') != ''){
              $('.categories').collapse('hide');
              $($(this).attr('data-toggle')).collapse('show');
              
              var prevCategories = $($(this).attr('data-toggle')).prev().attr('id');
              var nextCategories = $($(this).attr('data-toggle')).next().attr('id');
            // console.log(nextCategories);
            if(nextCategories != undefined){
                  $('.btn-next').attr('data-toggle',   '#'+nextCategories);   
            }else{
              $('.btn-next').attr('data-toggle',   '');   
            }
              
            
              if(prevCategories != undefined){
                  $('.btn-prev').attr('data-toggle',   '#'+prevCategories);  
              }else if(prevCategories =="#step-1"){
                  
                  
              }else{
                  $('.btn-prev').attr('data-toggle',   '');  
                  
              }   
          }
      }); 

      $('.btn-next').on('click', function(e){
          e.preventDefault();
    
      
      }); 
      

      if($('.wool-cotton .shoe').length){
          var sec2 = $('.sec2 .wool-cotton').offset().top;
          
          if((windowScroll + windowHeight -  prepare*0) > sec2){
              $('.wool-cotton .shoe-1').addClass('animated fadeInLeft');
              $('.wool-cotton .shoe-2').addClass('animated fadeInRight');
          }
          $(window).on('scroll', function(){
                  windowScroll = $(window).scrollTop();
                  sec2 = $('.sec2 .wool-cotton').offset().top;	
                  if((windowScroll + windowHeight -  prepare*0) > sec2){
                      $('.wool-cotton .shoe-1').addClass('animated fadeInLeft');
                      $('.wool-cotton .shoe-2').addClass('animated fadeInRight');
                  }
              
          });
      }

      if($('.sec6').length){
        var sec6 = $('.sec6').offset().top;
        
        if((windowScroll + windowHeight -  prepare*2) > sec6){
            $('.sec6 .animated').addClass('fadeInRight');
        }
        $(window).on('scroll', function(){
                windowScroll = $(window).scrollTop();
                sec6 = $('.sec6').offset().top;	
                if((windowScroll + windowHeight -  prepare*1.25) > sec6){
                    $('.sec6 .animated').addClass('fadeInRight');
                }
                //console.log(sec6);
                
            
        });
    }
  });
};

export default registerAnimations;
